window.Visualizations.Highcharts.StackedColumn = Object.assign({}, window.Visualizations.Highcharts.Base, {
  render: function (opts) {
    this.renderChart(opts.highchart_html_id, opts, {
      chart: {
        type: 'column'
      },
      xAxis: {
        categories: opts.categories
      },
      yAxis: {
        min: 0,
        title: {
          text: opts.y_title
        },
        labels: {
          formatter: function () {
            var label = this.axis.defaultLabelFormatter.call(this);
            if (opts.full_y_axis_label) return Highcharts.numberFormat(this.value, 0, '-', ',');
            return label;
          }
        }
      },
      showStackTotal: true,
      plotOptions: {
        column: {
          stacking: 'normal'
        }
      },
      legend:{
        maxHeight: 300,
        y: 20
      },      
      series: opts.series,
      colors: [
        '#A3C537',
        '#009FE3',
        '#2C3F3C',
        '#F09E02',
        '#6C145C',
        '#A54417',
        '#FDEEDC',
        '#277532',
        '#A31916',
        '#E6F5FE',
        '#647722',
        '#d3e29c',
        '#4fbded',
        '#c2ebd6',
        '#85d6ad',
        '#66cc99',
        'bbd3be',
      ]
    });
  }
});
